export interface ClientContactClass{
    AccountPartyContactId:number
    AccountPartyId	:number
    FirstName	:string
    LastName	:string
    Telephone1	:string
    Telephone2	:string
    Fax	:string
    EMailAddress	:string
    State	:string
    City	:string
    Zip	:string
    CountryId	:number
    CountryName : string
    Address1	:string
    Address2	:string
    AccountPartyDepartmentId	:number
    Location	:string
    AccountPartyContactGuidId	:string
    isSelected : number
}

const common = {    
    
    AccountPartyId	:0,
    FirstName	:"",
    LastName	:"",
    Telephone1	:"",
    Telephone2	:"",
    Fax	:"",
    EMailAddress	:"",
    State	:"",
    City	:"",
    Zip	:"",
    CountryId	:0,
    Address1	:"",
    Address2	:"",
    AccountPartyDepartmentId	:0,
    Location	:"",
    AccountPartyContactGuidId	:"",
  };
  
  export const ClientContactInitialsForAdd = { ...common };
  
  export const ClientContactInitialsForUpdate = {
    ...common,
    AccountPartyContactId:0
  };